<template>
  <div class="visualization-controls__select">
    <label for="dva">Deer-Vehicle Accident (DVA):</label>
    <multiselect
      :disabled="$props.disabled"
      :options="dvaOptions"
      :close-on-select="true"
      :clear-on-select="true"
      :preserve-search="false"
      :show-labels="false"
      :value="dvaSelections"
      @input="setDvaSelection"
    />
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },

  props: {
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },

  computed: {
    dvaOptions() {
      return ["Yes", "No"];
    },
    dvaSelections() {
      return this.$store.state.visualization.dvaSelection;
    },
  },

  watch: {
    disabled(newValue, oldValue) {
      console.log("new disabled value");
      if (newValue === true) {
        this.setDvaSelection("No");
      }
    },
  },

  methods: {
    ...mapMutations({
      setDva: "visualization/setDva",
      setDvaSelections: "visualization/setDvaSelection",
    }),
    setDvaSelection(dva) {
      this.setDvaSelections(dva);
      this.$emit("child-changed");
    },
  },
};
</script>

<style lang="scss" scoped></style>
